<div class="border-b border-gray-100">
    <div class="container-xxl gx-sm-9 gx-lg-10 gx-xxl-0">
        <ul class="d-flex align-items-center justify-content-start fs-10 py-6">
            @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
                <li class="text-gray-200">
                    @if (!last) {
                        <a class="font-secondary fw-500 text-gray-200" [routerLink]="breadcrumb.url | localize">{{ breadcrumb.name | translate }}</a>
                    }
                    @if (last) {
                        <span class="font-secondary fw-500 text-gray-500">{{ breadcrumb.name | translate }}</span>
                    }
                </li>
            }
        </ul>
    </div>
</div>
